import { useMediaQuery, useTheme } from '@material-ui/core'
import {
  PDFViewer,
  StyleSheet as PDFStyleSheet,
  pdf
} from '@react-pdf/renderer'
import { useState } from 'react'
import { toast } from 'react-toastify'

import { getTranslate } from '../../../localization'
import { BookingDetail } from '../../../types/bookingDetails'
import Main from './Page/Page'
import './index.css'

const styles = PDFStyleSheet.create({
  main: {
    width: '100vw',
    height: '100vh'
  }
})

interface CreatVoucherENProps {
  data: BookingDetail | undefined
  masterReservationNumber: string
  stripTagsWithNewlines(html: string): string[]
  splitTextByWords(inputString: string, maxLength: number): string[]
  loading: boolean
}

const CreatVoucherEN = ({
  data,
  masterReservationNumber,
  stripTagsWithNewlines,
  splitTextByWords,
  loading
}: CreatVoucherENProps) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [downloading, setDownloading] = useState(false)

  const handleDownload = async () => {
    if (!data) return
    setDownloading(true)
    try {
      const blob = await pdf(
        <Main
          data={data}
          masterReservationNumber={masterReservationNumber}
          stripTagsWithNewlines={stripTagsWithNewlines}
          splitTextByWords={splitTextByWords}
        />
      ).toBlob()

      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `voucher-${masterReservationNumber}.pdf`
      a.click()
      window.setTimeout(() => URL.revokeObjectURL(url), 60000)
    } catch {
      toast.error(getTranslate('Unable to generate voucher. Please try again.'))
    } finally {
      setDownloading(false)
    }
  }

  if (loading) return <div>{getTranslate('Loading...')}</div>
  return (
    <div style={{ textAlign: 'center' }}>
      {isMobile && (
        <button
          onClick={handleDownload}
          disabled={downloading}
          style={{
            padding: '10px 20px',
            fontSize: 16,
            marginBottom: 20,
            marginTop: 20,
            cursor: 'pointer'
          }}>
          {downloading
            ? getTranslate('Downloading...')
            : getTranslate('Download Voucher PDF')}
        </button>
      )}
      {data && !isMobile && (
        <PDFViewer style={styles.main}>
          <Main
            data={data}
            masterReservationNumber={masterReservationNumber}
            stripTagsWithNewlines={stripTagsWithNewlines}
            splitTextByWords={splitTextByWords}
          />
        </PDFViewer>
      )}
    </div>
  )
}

export default CreatVoucherEN
